/* RESPONSIBLE TEAM: team-standalone */
import Step from 'embercom/models/operator/visual-builder/step';
import type Store from '@ember-data/store';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';
import { TargetContext } from 'embercom/objects/operator/configuration/custom-bot';
import { attr } from '@ember-data/model';

export default class HandoffToExternalAgent extends Step {
  // The type of integration (e.g., 'zendesk', 'freshdesk')
  @attr('string') declare integrationType?: string;

  // The ID of the integration
  @attr('string') declare integrationId?: string;

  get typeKey() {
    // Make sure we return the key exactly as defined in stepTypes
    return 'handoff-to-external-agent';
  }

  get supportedChannels() {
    return SUPPORTED_CHANNELS.handoffToExternalAgent;
  }

  static get supportedContexts() {
    return [TargetContext.Conversation];
  }

  static get isStepGroupEnding() {
    return true;
  }

  static get isStepTerminal() {
    return true;
  }

  static createNewStep(store: Store, params?: Record<string, any>): HandoffToExternalAgent {
    return store.createRecord('operator/visual-builder/step/handoff-to-external-agent', {
      type: 'operator/visual-builder/step/handoff-to-external-agent',
      ...params, // Apply any additional parameters
    });
  }
}
